export const normalizeColumn = (column = {}) => ({
  ...column,
  dealIds: Array.isArray(column.dealIds) ? column.dealIds : []
});

export const normalizeFunnelSteps = (funnelSteps) => {
  if (!funnelSteps?.columns) return funnelSteps || {};

  const columns = {};
  Object.keys(funnelSteps.columns).forEach((id) => {
    columns[id] = normalizeColumn(funnelSteps.columns[id]);
  });

  const seen = new Set();
  const columnOrder = (funnelSteps.columnOrder || []).filter((id) => {
    if (!columns[id] || seen.has(id)) return false;
    seen.add(id);
    return true;
  });

  return {
    ...funnelSteps,
    columns,
    columnOrder
  };
};
